import { render } from "./NewClaimOverviewProductsTotals.vue?vue&type=template&id=59dc7dd7&scoped=true&ts=true"
import script from "./NewClaimOverviewProductsTotals.vue?vue&type=script&lang=ts"
export * from "./NewClaimOverviewProductsTotals.vue?vue&type=script&lang=ts"

import "./NewClaimOverviewProductsTotals.vue?vue&type=style&index=0&id=59dc7dd7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.9.3__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dc7dd7"]])

export default __exports__